import { API_ENDPOINT } from 'src/config/env.config';
import { BaseAPIResponse } from 'types';
import { baseApi } from './axios';

const baseUrl = `${API_ENDPOINT}/position-configuration`;

export interface PositionTitle {
    _id: string;
    name: string;
    label?: string;
    description?: string;
}

export interface PositionTechStack {
    _id: string;
    name: string;
    label?: string;
    description?: string;
}

export interface Skill {
    _id: string;
    name: string;
    description?: string;
    isSoftSkill?: boolean;
}

export interface GetPositionTitlesAPIResponse extends BaseAPIResponse {
    positionTitles?: PositionTitle[];
}

export interface GetPositionTechStacksAPIResponse extends BaseAPIResponse {
    techStacks?: PositionTechStack[];
}

export interface GetSkillsForTechStackAPIResponse extends BaseAPIResponse {
    skills?: Skill[];
}

export const getPositionTitles = async (): Promise<GetPositionTitlesAPIResponse> => {
    const response = await baseApi.get(`${baseUrl}/position-titles`);
    return response.data;
};

export const getPositionTechStacks = async (): Promise<GetPositionTechStacksAPIResponse> => {
    const response = await baseApi.get(`${baseUrl}/tech-stacks`);
    return response.data;
};

export const getTechStacksForPositionTitle = async (positionTitleId: string): Promise<GetPositionTechStacksAPIResponse> => {
    const response = await baseApi.get(`${baseUrl}/position-title/${positionTitleId}/tech-stacks`);
    return response.data;
};

export const getSkillsForTechStack = async (techStackId: string): Promise<GetSkillsForTechStackAPIResponse> => {
    const response = await baseApi.get(`${baseUrl}/tech-stack/${techStackId}/skills`);
    return response.data;
};

